import { Entry } from '../Entry'

export function Entry20241211_2() {
  return (
    <Entry title="2024 Dec 11 - v3.9.3">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/16227/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
